import React from 'react'
import { SvgIconProps } from '@material-ui/core'
import { CheckIconContainer } from './CheckIcon.style'

export const CheckIcon = (props: SvgIconProps) => <CheckIconContainer {...props} />

export default CheckIcon
